import { css, cx, keyframes } from "@emotion/css";

import { useTheme } from "@/modules/theme/hooks/useTheme";
import { grey, white } from "@/modules/theme/utils/colors";
import { fade } from "@/modules/theme/utils/fade";

const spinner = keyframes({
  from: {
    transform: "rotate(0deg)",
  },
  to: {
    transform: "rotate(360deg)",
  },
});

export type LoaderProps = {
  size: string | number;
  variant?: "neutral" | "primary" | "secondary";
  className?: string;
};

export function Loader({ size, variant = "neutral", className }: LoaderProps) {
  const { spacing, palette } = useTheme();
  const classes = {
    root: css({
      display: "block",
      width: size,
      height: size,
      border: `${spacing(0.5)} solid transparent`,
      borderRadius: "50%",
      animation: `${spinner} 1s ease infinite`,
    }),

    neutral: css({
      borderColor: fade(grey[500], 0.7),
      borderTopColor: white,
    }),

    primary: css({
      borderTopColor: palette.primary.main,
    }),
    secondary: css({
      borderTopColor: white,
    }),
  };

  return <div className={cx(classes.root, classes[variant], className)} />;
}
